import "$styles/index.css"
import "$styles/syntax-highlighting.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { initNavbar } from "./navbar.js"
import { initMapsLinks } from "./maps-link.js"
import { initHeader } from "./header.js"
import { initContactForm } from "./contact-form.js"

document.addEventListener("DOMContentLoaded", () => {
  initNavbar()
  initMapsLinks()
  initHeader()
  initContactForm()
})
